import { Repository } from "src/firebase/firestore/repository";
import { UserSpaceStats, UserStats } from "../types/user.entity";

export class UserStatsRepository extends Repository<UserStats> {
  constructor() {
    super("user_stats");
  }

  async findByUserId(userId: string): Promise<UserStats | null> {
    try {
      return await this.findById(userId);
    } catch (error) {
      console.error("Error fetching user stats:", error);
      return null;
    }
  }
}

export const userStatsRepository = new UserStatsRepository();

export class UserSpaceStatsRepository extends Repository<UserSpaceStats> {
  constructor() {
    super("user_space_stats");
  }

  async findByUserId(userId: string): Promise<UserSpaceStats[]> {
    try {
      return await this.find({
        where: { userId },
        limit: 50,
      });
    } catch (error) {
      console.error("Error fetching user space stats:", error);
      return [];
    }
  }
}

export const userSpaceStatsRepository = new UserSpaceStatsRepository();
